import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { LotAnalisiResponse } from '@produzionejb/types';
import { api } from '../lib/api-client';

function useLotAnalisi(lotId: string | null) {
  return useQuery({
    queryKey: ['lot-analisi', lotId],
    queryFn: () =>
      api<{ items: LotAnalisiResponse[]; total: number }>(
        `/api/lot-analisi${lotId ? `?lotId=${lotId}` : ''}`,
      ),
    enabled: !!lotId,
    staleTime: 30_000,
  });
}

export function LotAnalisiPicker({
  lotId,
  value,
  valueCodice,
  onChange,
  disabled,
}: {
  lotId: string | null;
  value: string | null;
  valueCodice?: string | null;
  onChange: (id: string | null, codice: string | null) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const analisiQ = useLotAnalisi(lotId);
  const display = valueCodice || (value ? value.slice(0, 8) : '');
  const isEmpty = analisiQ.data && analisiQ.data.items.length === 0;
  return (
    <div className="relative">
      <button
        type="button"
        className="w-full rounded-md border border-slate-300 px-2 py-1 text-left text-xs"
        onClick={() => !disabled && lotId && setOpen((v) => !v)}
        disabled={disabled || !lotId}
        title={!lotId ? 'Seleziona prima un lotto' : isEmpty ? 'Nessuna analisi disponibile per il lotto' : undefined}
      >
        {display || (isEmpty ? '— no analisi —' : '— scegli analisi —')}
      </button>
      {open && (
        <div className="absolute z-10 mt-1 w-72 rounded-md border border-slate-300 bg-white p-2 shadow-lg">
          {value && (
            <button
              type="button"
              onClick={() => {
                onChange(null, null);
                setOpen(false);
              }}
              className="mb-2 block w-full rounded border border-slate-200 bg-slate-50 px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
            >
              ✕ Rimuovi selezione
            </button>
          )}
          <ul className="max-h-56 overflow-y-auto text-xs">
            {analisiQ.isLoading && <li className="p-1 text-slate-400">Caricamento...</li>}
            {isEmpty && <li className="p-1 text-slate-400">Nessuna analisi disponibile</li>}
            {analisiQ.data?.items.map((a) => (
              <li
                key={a.id}
                className="cursor-pointer rounded p-1 hover:bg-slate-100"
                onClick={() => {
                  onChange(a.id, a.codice);
                  setOpen(false);
                }}
              >
                <span className="font-mono">{a.codice}</span>
                <span className="ml-2 text-slate-500">
                  {new Date(a.dataAnalisi).toLocaleDateString()}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
